export const categories = [
  { slug: 'yulequan', name: '娱乐圈', icon: 'ri-movie-2-line', description: '明星艺人、综艺节目、影视圈内幕曝光' },
  { slug: 'shangyequan', name: '商业圈', icon: 'ri-briefcase-4-line', description: '企业黑幕、商业欺诈、行业潜规则揭秘' },
  { slug: 'wanghong', name: '网红博主', icon: 'ri-live-line', description: '知名博主、直播网红翻车事件全收录' },
  { slug: 'zuixin', name: '最新曝光', icon: 'ri-flashlight-line', description: '最新最热的黑料曝光内容实时更新' },
  { slug: 'heji', name: '黑料合集', icon: 'ri-folder-2-line', description: '经典黑料事件汇总，一网打尽' },
];

export const articles = [
  {
    id: 'art-001',
    slug: 'dingji-nvxing-toushui-men',
    title: '某顶流女星偷税漏税风波：2.8亿税款去向成谜',
    excerpt: '据知情人士透露，该女星通过多层空壳公司转移收入，涉及金额高达2.8亿元。税务部门已介入调查，多名关联人员被约谈。',
    content: `据权威消息源透露，娱乐圈某顶流女星因涉嫌通过多层空壳公司转移个人收入，偷逃个人所得税及增值税合计约2.8亿元。该案件引发了社会各界的广泛关注。

知情人士表示，该女星在过去三年间，通过注册多家空壳公司，将个人演出收入、品牌代言费等包装成公司营业收入，再通过虚假发票、关联交易等手段将资金转移至境外账户。

税务稽查部门在例行检查中发现异常后，迅速成立了专案组进行深入调查。目前已有包括该女星的经纪人、财务顾问在内的多名关联人员被约谈。

"这种操作在圈内并不罕见，但涉及金额如此之大的确实少见。"一位不愿透露姓名的税务专家表示，"如果查实，不仅要补缴税款和滞纳金，还可能面临刑事处罚。"

该女星的粉丝群体对此反应强烈，部分粉丝在社交平台上发起声援，但也有不少网友表示"法律面前人人平等"。截至目前，该女星本人尚未就此事公开发声。其工作室仅发布简短声明称"正在积极配合有关部门调查"。

值得注意的是，这已经是今年曝出的第三起明星涉税案件。业内人士呼吁，娱乐圈应当加强自律，依法纳税是每一位公民应尽的义务。`,
    category: 'yulequan',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dramatic%20dark%20scene%20with%20spotlight%20on%20an%20empty%20stage%2C%20scattered%20documents%20and%20tax%20forms%20floating%20in%20the%20air%2C%20mysterious%20atmosphere%2C%20warm%20dark%20amber%20toned%20cinematic%20lighting%2C%20shallow%20depth%20of%20field%2C%20editorial%20photography%20style&width=1200&height=675&seq=article-yulequan-001&orientation=landscape',
    author: '黑料编辑部',
    publishedAt: '2026-08-06',
    readCount: 128500,
    tags: ['偷税漏税', '女明星', '税务调查', '娱乐圈黑幕'],
    featured: true,
    hot: true,
  },
  {
    id: 'art-002',
    slug: 'dianxian-dashang-fanshui',
    title: '知名电商平台刷单内幕：70%好评都是假的',
    excerpt: '调查记者卧底三个月，揭露某头部电商平台刷单产业链。从刷手招募到虚假交易，一条完整的灰色产业链浮出水面。',
    content: `经过三个月的卧底调查，本报记者揭露了某头部电商平台背后庞大的刷单产业链。据调查显示，该平台上约70%的好评来自专业刷单团队，严重误导了消费者的购买决策。

记者通过暗访了解到，刷单产业链已经形成了完整的分工：上游有专门的刷单平台负责接单和分配任务，中游有大量刷手负责执行虚假交易，下游则有技术团队提供改IP、虚拟定位等技术支持。

一位曾从事刷单业务的内部人士向记者透露："大卖家每月的刷单预算通常在10万到50万之间，赶上双十一、618这样的大促，预算能翻好几倍。平台其实心知肚明，但因为刷单能带来漂亮的GMV数据，所以睁一只眼闭一只眼。"

记者在调查中发现，刷单行为已经严重影响了平台的信用体系。一些质量一般的商品通过大量刷单冲上热销榜，而真正优质但没刷单的商品则被淹没在海量信息中。

消费者权益保护协会的负责人表示，刷单行为不仅违反了《反不正当竞争法》，还涉嫌欺诈消费者。他呼吁电商平台切实履行监管责任，建立更严格的评价审核机制。

目前，该电商平台尚未对此事做出正式回应。但据内部消息，平台近期已开始加强对异常交易行为的监测力度。`,
    category: 'shangyequan',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dark%20mysterious%20warehouse%20filled%20with%20cardboard%20boxes%20and%20computer%20screens%2C%20warm%20amber%20and%20shadow%20lighting%2C%20cinematic%20mood%2C%20suspenseful%20atmosphere%2C%20investigative%20journalism%20photography%20style&width=1200&height=675&seq=article-shangyequan-001&orientation=landscape',
    author: '黑料调查组',
    publishedAt: '2026-08-05',
    readCount: 96500,
    tags: ['电商平台', '刷单', '虚假好评', '商业黑幕'],
    featured: true,
    hot: true,
  },
  {
    id: 'art-003',
    slug: 'wanghong-daihuo-jiade',
    title: '百万粉丝网红直播带货假货：进价30卖300',
    excerpt: '某拥有500万粉丝的美食博主被曝直播带货产品存在严重质量问题，进价仅30元的"进口保健品"以300元高价售卖给粉丝。',
    content: `近日，拥有500万粉丝的知名美食博主"食神老张"被粉丝联合举报，其直播带货的"进口保健品"被证实为国内小作坊生产的假冒伪劣产品。

据多位购买者反映，该博主在直播间宣称售卖的是一款"日本原装进口胶原蛋白饮"，售价298元/盒。然而，有较真的粉丝将产品送检后发现，该产品不仅不含任何胶原蛋白成分，甚至连基本的卫生标准都不达标。

更令人震惊的是，调查发现该产品的出厂价仅为28元/盒，而该博主团队从中赚取的差价高达近10倍。据业内人士估算，仅这一个产品，该博主就从中获利超过800万元。

"我那么信任他，每场直播都买，没想到全是套路。"一位购买了该产品的粉丝在社交平台上发帖控诉，"吃完后拉了好几天肚子，去医院检查说是食物中毒。"

事件曝光后，该博主紧急删除了所有相关直播回放，并关闭了评论区。但愤怒的粉丝已经开始在各个平台扩散此事，相关话题迅速登上热搜。

市场监管部门表示已介入调查。如果属实，该博主将面临巨额罚款，甚至可能被追究刑事责任。该事件也再次引发了社会对直播带货行业监管的广泛讨论。

多位业内人士呼吁，应当尽快出台直播带货行业规范，建立主播信用档案，对售假行为实行"一票否决"，切实保护消费者权益。`,
    category: 'wanghong',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dramatic%20scene%20of%20a%20livestream%20studio%20with%20products%20scattered%20on%20the%20floor%2C%20ring%20light%20casting%20harsh%20shadows%2C%20dark%20moody%20atmosphere%2C%20warm%20toned%20cinematic%20lighting%2C%20documentary%20photography%20style&width=1200&height=675&seq=article-wanghong-001&orientation=landscape',
    author: '黑料编辑部',
    publishedAt: '2026-08-04',
    readCount: 85600,
    tags: ['直播带货', '假货', '网红翻车', '消费者权益'],
    featured: true,
    hot: true,
  },
  {
    id: 'art-004',
    slug: 'yingshi-gongsichouwen',
    title: '某影视公司CEO潜规则女演员：录音曝光震动娱乐圈',
    excerpt: '一段长达47分钟的录音在网络疯传，某知名影视公司CEO在私人饭局中暗示女演员"陪酒换角色"，引发舆论哗然。',
    content: `昨日晚间，一段长达47分钟的录音在网络疯传，内容涉及某知名影视公司CEO在私人饭局中对多位女演员的"潜规则"言论，在娱乐圈引起轩然大波。

录音中，该CEO以"给角色"为诱饵，暗示年轻女演员需要"付出一些代价"。录音中还提到了多位圈内知名人士的名字，涉及范围之广令人震惊。

"这段录音太真实了，听完浑身发冷。"一位业内小型经纪公司的负责人在接受采访时表示，"其实圈内人都知道这些事，只是一直没人敢站出来说。这次录音曝光，希望能推动行业变革。"

中国电视剧制作产业协会发表声明称，对此类行为"零容忍"，将配合有关部门严肃处理。多个影视公司也纷纷发声，表示将加强内部管理，杜绝类似事件发生。

法律专家指出，如果录音内容属实，该CEO的行为已涉嫌违法。"利用职务之便对他人进行性骚扰或胁迫，不仅违反职业道德，还可能构成犯罪。"

截至目前，涉事CEO尚未做出回应。其所在公司发布公告称"正在核实相关情况，将在查明事实后依法依规处理"。`,
    category: 'yulequan',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dark%20luxurious%20private%20dining%20room%20with%20an%20empty%20table%20and%20overturned%20wine%20glass%2C%20dramatic%20shadow%20play%2C%20warm%20amber%20cinematic%20lighting%2C%20mysterious%20and%20tense%20atmosphere%2C%20editorial%20photography&width=1200&height=675&seq=article-yulequan-002&orientation=landscape',
    author: '黑料调查组',
    publishedAt: '2026-08-03',
    readCount: 156200,
    tags: ['影视公司', '潜规则', '女演员', '录音曝光'],
    featured: false,
    hot: true,
  },
  {
    id: 'art-005',
    slug: 'hulianwang-jumin-weigui',
    title: '互联网巨头违规收集用户隐私：你的每一次点击都被卖了',
    excerpt: '工信部通报某互联网巨头旗下15款App存在过度收集用户个人信息行为，涉及通讯录、位置、相册等敏感权限。',
    content: `工业和信息化部昨日发布通报，指出某互联网巨头旗下15款App存在违规收集和使用用户个人信息的行为，问题严重，影响范围广泛。

通报显示，这些App在用户不知情或未明确同意的情况下，擅自收集用户的通讯录、精确位置信息、相册照片、短信记录等敏感数据，并将这些数据用于商业分析和精准广告投放。

"这不仅仅是隐私问题，这是赤裸裸的数据窃取。"一位网络安全专家表示，"这些数据被收集后会形成详细的用户画像，包括你的社交关系、消费习惯、行动轨迹，甚至健康状况。这些画像在数据黑市上可以被卖出高价。"

据调查，一条包含完整用户画像的数据包在黑市上的价格在5元到50元不等。按照该互联网巨头数亿的用户规模计算，这已经形成了一个价值数十亿的灰色产业链。

中国消费者协会对此表示高度关注，呼吁监管部门加大执法力度，对屡教不改的企业予以重罚。同时，消费者协会建议用户定期检查手机App权限设置，关闭不必要的授权。

该互联网巨头回应称"高度重视用户隐私保护"，已成立专项工作组进行整改，并承诺在30天内完成所有App的权限合规审查。`,
    category: 'shangyequan',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dark%20server%20room%20with%20blinking%20lights%2C%20shadowy%20figure%20silhouette%20in%20front%20of%20data%20screens%2C%20mysterious%20digital%20surveillance%20theme%2C%20warm%20and%20cool%20contrast%20lighting%2C%20cinematic%20tech%20noir%20style&width=1200&height=675&seq=article-shangyequan-002&orientation=landscape',
    author: '黑料编辑部',
    publishedAt: '2026-08-02',
    readCount: 72300,
    tags: ['用户隐私', '数据泄露', '互联网巨头', '工信部'],
    featured: false,
    hot: false,
  },
  {
    id: 'art-006',
    slug: 'meizhuang-bozhu-chanpinwei',
    title: '美妆博主带货"三无"产品：粉丝用后脸部溃烂',
    excerpt: '拥有300万粉丝的美妆博主"小仙女Cici"被多名粉丝实名举报，其推荐的美容仪为"三无"产品，已导致多人面部受损。',
    content: `知名美妆博主"小仙女Cici"近日陷入严重信任危机。其力推的一款"韩国进口美容仪"被证实为没有生产许可证、没有合格证、没有生产日期的"三无"产品，已有多名消费者使用后出现面部红肿、溃烂等严重不良反应。

受害者李女士（化名）向记者展示了她的就医记录和面部照片。"我花了1980元买了这个美容仪，用了三次脸就开始发红发痒，到第五次的时候脸上直接溃烂了。去医院诊断为接触性皮炎，医生说是因为仪器表面涂层含有重金属超标。"

据不完全统计，已有超过200名消费者出现了类似的症状。然而，该博主在事发后不仅没有道歉，反而发布声明称"产品经过严格筛选，个别过敏反应属于正常现象"，甚至暗示受害者是"竞争对手派来的水军"。

这一回应彻底激怒了消费者群体。多位受害者已经联合委托律师，准备对该博主及产品生产方提起集体诉讼。某消费者权益保护组织也表示将为受害者提供法律援助。

业内人士分析指出，网红带货行业存在严重的监管真空。很多博主为了高额佣金，根本不会对产品进行实际测试和质量审核。"他们把粉丝的信任当作了赚钱的工具。"`,
    category: 'wanghong',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20beauty%20studio%20with%20broken%20mirror%20and%20scattered%20cosmetics%2C%20dramatic%20shadow%20lighting%2C%20dark%20moody%20atmosphere%2C%20warm%20amber%20tones%2C%20cinematic%20documentary%20photography%20style&width=1200&height=675&seq=article-wanghong-002&orientation=landscape',
    author: '黑料调查组',
    publishedAt: '2026-08-01',
    readCount: 110400,
    tags: ['美妆博主', '三无产品', '美容仪', '面部溃烂'],
    featured: false,
    hot: true,
  },
  {
    id: 'art-007',
    slug: 'dichan-dacao-neimu',
    title: '某地产巨头资金链断裂内幕：数万业主恐无法收房',
    excerpt: '某TOP10房企被曝资金链断裂，全国超过30个项目停工。内部文件显示，公司负债总额已超过8000亿元。',
    content: `一份据称来自某TOP10房地产企业内部的文件近日在网络流传，内容震惊业界。文件显示，该企业总负债已超过8000亿元，现金流严重不足，全国超过30个在建项目已经停工或处于半停工状态。

记者走访了位于杭州、武汉、成都等地的多个停工项目现场。在杭州某楼盘，数百名业主聚集在售楼处门口，举着"还我血汗钱"的横幅维权。

"我掏空了六个钱包买的房子，现在工地一个人都没有，交房遥遥无期。"一位购房者张先生声音哽咽，"每个月还要还一万多的房贷，我真的撑不下去了。"

据内部员工透露，该企业早在2025年初就已经出现资金周转困难，但一直在通过"借新还旧"维持表面运转。"公司高层不断安抚我们说资金马上到位，结果等到最后连工资都发不出来了。"

多位房地产业内人士表示，这可能是近年来最大规模的房企暴雷事件。"如果处理不好，将引发连锁反应，对整个行业和金融系统造成巨大冲击。"

目前，地方政府已经介入协调，承诺"保交楼、保民生"。但具体方案和时间表尚未公布，数万业主的维权之路仍充满未知。`,
    category: 'shangyequan',
    coverImage: 'https://readdy.ai/api/search-image?query=Abandoned%20construction%20site%20with%20unfinished%20buildings%20and%20cranes%2C%20dark%20cloudy%20sky%2C%20dramatic%20atmosphere%2C%20warm%20toned%20documentary%20photography%2C%20urban%20decay%20mood&width=1200&height=675&seq=article-shangyequan-003&orientation=landscape',
    author: '黑料编辑部',
    publishedAt: '2026-07-30',
    readCount: 189000,
    tags: ['房地产', '资金链断裂', '烂尾楼', '业主维权'],
    featured: false,
    hot: true,
  },
  {
    id: 'art-008',
    slug: 'zhiming-zhuchi-lianai',
    title: '知名主持人隐婚出轨实锤：深夜与神秘女子酒店共度8小时',
    excerpt: '某卫视王牌主持人被拍到深夜与一名年轻女子进入酒店，直到次日清晨才离开。随后该主持人在社媒发文否认，但证据确凿。',
    content: `某省级卫视金牌主持人"阿浩"近日被狗仔拍到深夜与一名年轻女子进入某五星级酒店，两人在酒店内共度约8小时后才先后离开。更令人震惊的是，该主持人早已结婚且有子女。

偷拍画面显示，当晚11点左右，"阿浩"与一名身穿黑色连衣裙的长发女子在酒店大堂会面，两人举止亲密，随后一同乘坐电梯进入客房楼层。直到次日早上7点，该主持人才独自离开酒店，而那名女子则在一个小时后才走出大堂。

事件曝光后，"阿浩"第一时间在微博发文否认，称该女子只是"工作合作伙伴"，两人当晚是在"讨论新节目的方案"。然而，这一解释遭到了网友的集体嘲讽。

"讨论方案需要去酒店房间讨论？还从晚上11点讨论到早上7点？这是什么神仙方案需要讨论这么久？"一条获得数万点赞的评论如此写道。

该主持人的妻子据称在得知消息后情绪崩溃，已带孩子暂时搬回娘家居住。其所在电视台表示"正在了解情况"，但尚未做出停职等处理决定。

业内人士表示，该主持人是该卫视的主力台柱，年收入据估算在2000万以上。如果此次事件处理不当，不仅影响个人形象，也可能影响其代言的多个商业品牌。`,
    category: 'yulequan',
    coverImage: 'https://readdy.ai/api/search-image?query=Luxury%20hotel%20entrance%20at%20night%20with%20dramatic%20shadow%20and%20mysterious%20atmosphere%2C%20warm%20lobby%20lights%2C%20cinematic%20noir%20style%2C%20paparazzi%20photography%20vibe&width=1200&height=675&seq=article-yulequan-003&orientation=landscape',
    author: '黑料调查组',
    publishedAt: '2026-07-28',
    readCount: 203000,
    tags: ['主持人', '出轨', '隐婚', '酒店'],
    featured: false,
    hot: true,
  },
  {
    id: 'art-009',
    slug: 'shipin-erchuang-qinquan',
    title: '短视频"二次创作"灰色地带：侵权还是创意？行业大讨论',
    excerpt: '随着短视频平台兴起，"二次创作"类内容的版权争议日益激烈。多位原创作者联合发声，指控头部账号未经授权擅用其作品。',
    content: `近段时间以来，关于短视频"二次创作"是否构成侵权的争议愈演愈烈。多位电影导演、电视剧编剧和音乐人联合发表公开信，指责部分拥有数百万粉丝的短视频账号未经授权擅自剪辑、改编其作品，严重侵犯了原创者的合法权益。

"他们把我的电影剪成三分钟的解说视频，配上自己的旁白，就变成了'原创内容'，然后涨粉几百万、赚取巨额流量收益。"一位知名导演在接受采访时愤怒地表示，"而我和我的团队花了两三年拍的电影，反而成了他们的'素材库'。"

然而，"二次创作"创作者们也提出了不同观点。一位粉丝数超过800万的影视解说博主表示："我们的作品给原片带来了巨大的曝光量，很多观众是看了我们的视频才去影院支持原片的。这是一种共赢关系，而不是侵权。"

法律专家指出，判断"二次创作"是否侵权，关键在于是否构成"合理使用"。"如果二次创作仅仅是截取原作品的片段，加上简单的解说，没有形成新的表达，那很可能构成侵权。但如果二次创作形成了新的独创性内容，例如深度影评、讽刺性改编等，则可能受到合理使用原则的保护。"

目前，国家版权局已着手研究制定短视频"二次创作"的版权管理规范。业内人士预计，相关的行业标准有望在年内出台。`,
    category: 'heji',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20split%20screen%20showing%20original%20film%20footage%20on%20one%20side%20and%20short%20video%20editing%20timeline%20on%20the%20other%2C%20dramatic%20contrast%20lighting%2C%20warm%20toned%20documentary%20style&width=1200&height=675&seq=article-heji-001&orientation=landscape',
    author: '黑料编辑部',
    publishedAt: '2026-07-25',
    readCount: 56700,
    tags: ['短视频', '版权', '二次创作', '侵权争议'],
    featured: false,
    hot: false,
  },
  {
    id: 'art-010',
    slug: 'kuaican-lianjiashipin',
    title: '网红餐厅后厨曝光：馊了的食材照样上桌，蟑螂遍地爬',
    excerpt: '某网红连锁餐厅后厨暗访视频曝光，画面中腐烂食材、蟑螂老鼠随处可见。该品牌全国拥有200多家门店，年营收超10亿。',
    content: `一段由离职员工偷拍的后厨视频在网络疯传，画面中的场景令人触目惊心。某拥有200多家门店的网红连锁餐厅后厨内，腐烂发臭的食材被继续使用、蟑螂在操作台上肆意爬行、工作人员不戴手套直接用手抓取食物——而这些食物最终被端上了消费者的餐桌。

视频显示，一份明显已经变色发黏的牛肉，被厨师直接扔进锅中烹制。"反正加够调料就盖住味了，客人吃不出来。"视频中一位厨师的声音清晰可辨。

更令人震惊的是，视频拍摄者——一位前员工——透露，这种情况并非偶然。"每天都是这样，从来没有变过。公司为了控制成本，要求后厨不能浪费食材，哪怕过期变质也要想办法用掉。如果有人举报，店长会威胁开除。"

事件曝光后，该餐厅品牌方发表声明称"视频内容存在恶意剪辑，不排除竞争对手恶意抹黑"，但并未否认后厨卫生问题。这一回应引发了消费者的强烈不满。

食品安全监管部门已对该品牌所有门店展开突击检查，目前已有多家门店被责令停业整顿。一位执法人员表示："检查结果令人震惊，我们当场查封了大量过期变质食材。"

该事件再次敲响了食品安全警钟。消费者权益保护组织呼吁，应当建立"明厨亮灶"的强制标准，让餐饮后厨完全透明化。`,
    category: 'shangyequan',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dark%20dirty%20restaurant%20kitchen%20with%20dim%20lighting%2C%20messy%20countertops%2C%20dramatic%20shadow%2C%20warm%20cinematic%20horror%20documentary%20style%2C%20health%20violation%20scene&width=1200&height=675&seq=article-shangyequan-004&orientation=landscape',
    author: '黑料调查组',
    publishedAt: '2026-07-22',
    readCount: 245000,
    tags: ['网红餐厅', '食品安全', '后厨', '暗访曝光'],
    featured: false,
    hot: true,
  },
  {
    id: 'art-011',
    slug: 'zhibo-dashen-jiade',
    title: '游戏主播代打代练黑产链：月入百万，平台默许',
    excerpt: '调查发现，某知名直播平台上排名前十的游戏主播中，超过一半存在代打代练行为。背后是一条分工明确的灰色产业链。',
    content: `近年来，游戏直播行业发展迅猛，但繁荣背后暗藏一条庞大的代打代练灰色产业链。本报记者深入调查发现，在某头部直播平台上，排名前十的游戏主播中至少有六人存在代打行为——观众在直播中看到的精彩操作，实际上并非主播本人完成。

调查显示，代打产业链分工精细。顶端是"代打工作室"，负责招募和培训技术高超的游戏玩家；中间层是"经纪人"，负责对接主播需求和代打资源；底层的代打玩家则负责实际执行。

"一个顶级游戏主播每月花在代打上的费用大约是5到10万元，但他们通过直播礼物和广告收入能赚到50到100万。"一位前代打工作室员工透露，"平台其实知道这些，但只要不闹大，就会默许。毕竟头部主播能给平台带来巨大的流量和收入。"

法律专家表示，代打行为涉嫌欺诈。"观众打赏是基于对主播个人技术的认可和信任，如果实际操作的另有其人，那就构成了对消费者的欺诈。同时，这种行为也破坏了游戏竞技的公平性。"

多个游戏开发商已表示将加大对代打行为的打击力度。某知名游戏公司发言人称："我们正在研发更先进的技术手段来识别代打行为，一经发现，将永久封禁相关账号。但归根结底，还需要平台方的积极配合。"`,
    category: 'wanghong',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dark%20gaming%20room%20with%20multiple%20computer%20screens%2C%20shadowy%20figures%2C%20dramatic%20RGB%20and%20warm%20contrast%20lighting%2C%20cyberpunk%20documentary%20atmosphere&width=1200&height=675&seq=article-wanghong-003&orientation=landscape',
    author: '黑料编辑部',
    publishedAt: '2026-07-20',
    readCount: 89400,
    tags: ['游戏主播', '代打', '直播平台', '灰色产业'],
    featured: false,
    hot: false,
  },
  {
    id: 'art-012',
    slug: 'guonei-yiren-heiyue',
    title: '娱乐圈"阴阳合同"再升级：片酬拆分手段更隐蔽',
    excerpt: '继某知名演员阴阳合同事件后，娱乐圈的避税手段不仅没有收敛，反而变得更加隐蔽和复杂，涉及境外信托、艺术品投资等新型方式。',
    content: `自2018年某知名演员因"阴阳合同"被处以巨额罚款后，公众一度以为娱乐圈的避税现象会得到遏制。然而，近期的调查显示，影视行业的避税手段不仅没有消失，反而变得更加隐蔽和复杂化。

据一位资深的影视行业财务人员透露，目前圈内流行的避税方式已经从简单的"阴阳合同"升级为多层嵌套的复杂架构。"现在流行的是'境外信托+艺术品投资'的组合模式。片酬先以投资名义打到境外公司，再通过艺术品交易、版权授权等方式回流。"

记者了解到，某知名导演的一部新片总投资1.2亿元，但实际上有近5000万通过层层嵌套最终流入了该导演的个人境外账户。而这一切在表面上都有合法的合同和发票作为支撑。

"税务部门也不是没有察觉，但取证难度极大。"一位税务稽查人员表示，"这些资金往往经过多个国家和地区的多个账户转移，调查需要跨国协作，时间周期很长。"

中国电影家协会已就此问题召开专题会议，呼吁行业自律。"高片酬本身不是问题，问题是偷逃税款是国家法律明令禁止的行为。影视从业者应当以身作则，依法纳税。"

据悉，国家税务总局近期已将影视行业列为重点稽查行业，新一轮的税务专项检查即将展开。行业内部已经开始流传"黑名单"，涉及数十位知名演员和导演。`,
    category: 'yulequan',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20luxurious%20office%20with%20contracts%20and%20money%20on%20a%20dark%20wooden%20desk%2C%20dramatic%20warm%20lighting%20from%20a%20single%20lamp%2C%20mysterious%20atmosphere%2C%20noir%20cinematic%20style&width=1200&height=675&seq=article-yulequan-004&orientation=landscape',
    author: '黑料调查组',
    publishedAt: '2026-07-18',
    readCount: 135000,
    tags: ['阴阳合同', '逃税', '片酬', '娱乐圈'],
    featured: false,
    hot: true,
  },
  {
    id: 'art-013',
    slug: 'zhubo-yinshi-jiankang',
    title: '网红代餐饮品致癌风波：月销10万单的"健康饮品"成夺命毒药',
    excerpt: '某网红代餐品牌被曝产品中含有违禁成分西布曲明，已导致全国多名消费者出现心悸、肝肾损伤等严重症状。',
    content: `备受年轻人追捧的网红代餐品牌"轻盈日记"近日被推上风口浪尖。多地消费者投诉，在长期服用该品牌代餐饮品后出现了心悸、失眠、肝功能异常等症状。经第三方检测机构检验，产品中检出了国家明令禁止添加的减肥药物成分——西布曲明。

西布曲明是一种中枢神经抑制剂，曾作为减肥药使用，但因会增加心脑血管疾病风险，早在2010年就被中国药监部门禁用。然而，该网红品牌却将其秘密添加到所谓的"纯天然植物代餐粉"中。

"我以为喝的是健康饮品，结果是毒药。"受害者陈女士说，她连续服用了三个月，体重下降了15斤，但也付出了惨痛代价——被诊断为药物性肝损伤，需要长期治疗。

更令人愤怒的是，该品牌的创始人在事发后试图卷款潜逃。据警方通报，该创始人已在机场被拦截，目前因涉嫌生产销售有毒有害食品罪被刑事拘留。

该品牌在某电商平台的月销量曾一度突破10万单，累计销售额估算超过5亿元。平台的审核漏洞也因此次事件被重新审视。多个电商平台已紧急下架该品牌全部产品。

营养学专家提醒消费者，任何声称"快速瘦身""无需运动"的减肥产品都应保持警惕。"真正健康的减肥只有一条路：合理饮食加规律运动。靠吃产品瘦身，不是在减重，是在减寿。"`,
    category: 'wanghong',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dark%20laboratory%20scene%20with%20scattered%20dietary%20supplement%20bottles%2C%20warning%20sign%2C%20dramatic%20amber%20lighting%2C%20mysterious%20atmosphere%2C%20medical%20documentary%20photography&width=1200&height=675&seq=article-wanghong-004&orientation=landscape',
    author: '黑料编辑部',
    publishedAt: '2026-07-15',
    readCount: 312000,
    tags: ['代餐', '致癌', '西布曲明', '网红品牌'],
    featured: false,
    hot: true,
  },
  {
    id: 'art-014',
    slug: 'zhuchiren-daoyan-fenbo',
    title: '综艺节目暗箱操作揭秘：淘汰名单内定，观众投票只是演戏',
    excerpt: '某选秀节目前工作人员爆料，节目中所有淘汰结果均为内定，观众投票只是走形式。节目组还在选手宿舍装窃听器制造话题。',
    content: `一位曾在某头部选秀综艺节目工作三年的前员工，近日在社交媒体上发布长文，详细揭露了选秀节目的各种暗箱操作手段，引发了舆论的广泛关注。

据该前员工披露，节目中所有的淘汰结果都是提前确定的。"所谓的观众投票根本不影响结果，节目组有专门的技术团队负责修改后台数据。观众看到的票数和排名，都是按照剧本'演'出来的。"

更令人震惊的是，节目组为了制造节目效果，在选手宿舍中偷偷安装了窃听器和隐蔽摄像头，24小时监控选手的私人对话。"一旦有选手说了什么能引起争议的话，剪辑组就会把它放大剪辑，甚至断章取义来制造冲突。"

"'虐粉'其实是有一套完整的方法论的。"该前员工透露，"先让一个选手的镜头变多，让观众喜欢上他，然后故意剪辑一些负面片段，让观众为他争论。等热度上来后，再安排他'惊险晋级'。这一套下来，粉丝更死忠，话题度也更高。"

对此，多位曾经参与过该节目的选手也纷纷发声证实。一位已转行开火锅店的退役选手表示："参加完那档节目后我一度抑郁，因为你所有的努力最后都变成了别人剧本里的一行字。"

广电总局此前已多次发文要求规范综艺节目制作，但业内人士表示，在巨大的商业利益面前，种种乱象短期内恐难根本改观。`,
    category: 'yulequan',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dark%20behind%20the%20scenes%20TV%20studio%20with%20empty%20stage%20and%20spotlights%2C%20control%20room%20with%20monitors%2C%20mysterious%20cinematic%20lighting%2C%20warm%20toned%20documentary%20photography&width=1200&height=675&seq=article-yulequan-005&orientation=landscape',
    author: '黑料调查组',
    publishedAt: '2026-07-12',
    readCount: 178000,
    tags: ['综艺节目', '暗箱操作', '选秀', '内定'],
    featured: false,
    hot: true,
  },
  {
    id: 'art-015',
    slug: 'zhiye-dajia-neimu',
    title: '职业打假人灰产链：不是打假，是敲诈',
    excerpt: '记者暗访发现，部分"职业打假人"已演变为专业敲诈团队。他们以索赔为目的，专门针对中小商家实施恶意举报和威胁。',
    content: `"职业打假人"原本是维护消费者权益的正面角色，然而记者近期的调查发现，这一行业已经异化为一条专业的敲诈产业链。

记者通过暗访加入了一个"职业打假交流群"，群内有超过3000名成员。群里每天分享的不是如何发现假货、举报不良商家，而是"哪个平台容易搞钱""怎么找小卖家的漏洞""索赔话术模板"等内容。

"真正的打假是去举报那些制假售假的大厂。但我们这行，说白了就是找软柿子捏。"一位群内的"资深打假人"坦言，"中小卖家没有法务团队，被盯上了只能认栽赔钱。一个投诉500块，一天搞10个就是5000，比上班强多了。"

记者发现，这些人会专门寻找商品详情页中的微小瑕疵——比如忘记标注执行标准号、产品参数写得不规范等——然后以"虚假宣传""三无产品"等名义向平台投诉或向市场监管部门举报。大多数商家为了息事宁人，会选择私下赔偿。

一位被敲诈过的淘宝店主无奈地表示："我卖的是自己手工做的饰品，一年也就赚几万块。结果被一个'打假人'盯上，说我的产品没有生产许可证，要我赔5000。我不肯，他就天天投诉，最后我的店铺被平台关了半个月。我只好给钱了事。"

法律专家指出，"职业打假人"如果以非法占有为目的，通过威胁、要挟等手段索取财物，其行为已涉嫌敲诈勒索罪。多地法院也已在相关判例中明确否定了"以打假为名行敲诈之实"的行为。`,
    category: 'heji',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dark%20room%20with%20a%20person%20typing%20on%20a%20laptop%2C%20legal%20documents%20scattered%2C%20dramatic%20shadow%20lighting%2C%20warm%20amber%20noir%20atmosphere%2C%20investigative%20journalism%20style&width=1200&height=675&seq=article-heji-002&orientation=landscape',
    author: '黑料编辑部',
    publishedAt: '2026-07-10',
    readCount: 67000,
    tags: ['职业打假', '敲诈', '灰产', '消费者权益'],
    featured: false,
    hot: false,
  },
  {
    id: 'art-016',
    slug: 'yinyue-jiaochao-xi',
    title: '音乐圈抄袭风波：爆款歌曲竟有80%涉嫌抄袭？',
    excerpt: '专业音乐人分析指出，近三年内国内音乐平台上的热门歌曲中，有超过80%存在不同程度的抄袭或"借鉴"国外作品的情况。',
    content: `一场关于华语音乐抄袭的大讨论正在社交媒体上蔓延。某知名音乐制作人在微博发文称，经过专业人士的逐一比对，近三年各大音乐平台上播放量过亿的"原创"热门歌曲中，有超过80%都存在不同程度的抄袭或"高度借鉴"国外作品的情况。

该制作人发布了一份详细的对比清单，列出了超过50首华语热门歌曲及其"疑似来源"。令人震惊的是，其中不少歌曲的旋律几乎与原曲完全一致，仅仅是换了中文歌词。

"这不是借鉴，这根本就是翻译填词。"该制作人在文中写道，"有些制作人专门去Spotify上找一些小众外语歌曲，直接拿来改个中文词就当成自己的原创发表。因为原作太小众了，听众根本发现不了。"

事件发酵后，多位被点名的歌手和制作人纷纷回应。有人承认"确实参考了某首歌的编曲思路"，有人则坚决否认"纯属巧合"，还有人选择沉默。

音乐版权律师表示，根据《著作权法》，旋律的实质性相似即构成侵权。"如果两首歌的旋律在普通人听来'很像'，那基本上就构成侵权了。但目前国内的音乐抄袭认定标准还不够清晰，维权成本也很高。"

中国音乐著作权协会呼吁，应当建立更加透明的音乐创作溯源机制，加强对原创音乐的保护力度。`,
    category: 'heji',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dark%20music%20studio%20with%20sheet%20music%20scattered%20on%20the%20floor%2C%20silhouette%20of%20a%20person%20at%20a%20piano%2C%20dramatic%20warm%20lighting%2C%20mysterious%20cinematic%20atmosphere&width=1200&height=675&seq=article-heji-003&orientation=landscape',
    author: '黑料调查组',
    publishedAt: '2026-07-08',
    readCount: 92000,
    tags: ['音乐抄袭', '原创', '版权', '华语音乐'],
    featured: false,
    hot: false,
  },
];

export const getArticlesByCategory = (categorySlug: string) => {
  if (categorySlug === 'zuixin') {
    return [...articles].sort((a, b) => new Date(b.publishedAt).getTime() - new Date(a.publishedAt).getTime());
  }
  return articles.filter((a) => a.category === categorySlug);
};

export const getArticleBySlug = (slug: string) => {
  return articles.find((a) => a.slug === slug);
};

export const getFeaturedArticles = () => articles.filter((a) => a.featured);
export const getHotArticles = () => articles.filter((a) => a.hot);
export const getLatestArticles = (limit: number = 10) => {
  return [...articles].sort((a, b) => new Date(b.publishedAt).getTime() - new Date(a.publishedAt).getTime()).slice(0, limit);
};

export const getRelatedArticles = (article: typeof articles[0], count: number = 4) => {
  const sameCategory = articles.filter((a) => a.category === article.category && a.id !== article.id);
  const others = articles.filter((a) => a.category !== article.category && a.id !== article.id);
  return [...sameCategory, ...others].slice(0, count);
};